import * as zod from 'zod';

export const HapticDeviceConfiguration = zod.object({
  kind: zod.literal('HapticDevice'),
  name: zod.string().default('Haptic Device'),
});

export type HapticDeviceConfiguration = zod.infer<
  typeof HapticDeviceConfiguration
>;
